import { motion } from "framer-motion";
import { useIntl } from "react-intl";

export const ContactUsListing = () => {
  const intl = useIntl();
  const bgImagePath = `${window.location.origin}/image/landingPage/contactUs.png`;

  return (
    <div id="contact">
      <div
        className="relative min-h-screen bg-center bg-cover"
        style={{
          backgroundImage: `url('${bgImagePath}')`,
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20">
          <div className="container flex flex-col items-center justify-between w-full h-full px-4 py-10 mx-auto">
            {/* Title Block */}
            <motion.div
              className="bg-[#b49f85] absolute left-0 md:w-1/2 md:top-52 top-24 md:px-20 px-6 py-4 z-40"
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <div className="mb-6 text-3xl font-bold">
                {intl.formatMessage({ id: "contactUs.title" })}
              </div>
              <div className="border-l-4 ps-4 border-[#6e5f49] text-lg text-white md:mb-4 mb-2">
                {intl.formatMessage({ id: "contactUs.desc" })}
              </div>
            </motion.div>

            {/* Contact Info Block */}
            <motion.div
              className="container h-full mx-auto md:pt-12"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="bg-[#d0cece] w-full md:w-3/5 md:h-2/3 h-full md:mt-24 md:pt-56 pt-64 md:px-20 px-4 flex flex-col md:gap-5">
                <div className="items-start md:flex">
                  <div className="flex items-start gap-4 mb-4 md:w-1/2 md:mb-0">
                    <img
                      src="/image/landingPage/icon/whatsApp.png"
                      className="w-8 h-8 mt-1"
                    />
                    <div>
                      <div>
                        {intl.formatMessage({ id: "contactUs.whatsappUs" })}
                      </div>
                      <div>
                        {intl.formatMessage({ id: "contactUs.contactNo" })}
                      </div>
                    </div>
                  </div>
                  {/* <div className="flex items-start gap-4 mb-4 md:w-1/2 md:mb-0">
                    <img
                      src="/image/landingPage/icon/location.png"
                      className="w-8 h-8 mt-1"
                    />
                    <div>{intl.formatMessage({ id: "contactUs.address" })}</div>
                  </div> */}
                </div>

                <div className="items-start md:flex">
                  <div className="flex items-start gap-4 mb-4 md:w-1/2 md:mb-0">
                    <img
                      src="/image/landingPage/icon/email.png"
                      className="w-8 h-8 mt-1"
                    />
                    <div>
                      <div>
                        {intl.formatMessage({ id: "contactUs.emailUs" })}
                      </div>
                      <div>{intl.formatMessage({ id: "contactUs.email" })}</div>
                    </div>
                  </div>
                  {/* <div className="flex items-start gap-4 mb-4 md:w-1/2 md:mb-0">
                    <img
                      src="/image/landingPage/icon/workingTime.png"
                      className="w-8 h-8 mt-1"
                    />
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: intl.formatMessage({
                            id: "contactUs.workingHour1",
                          }),
                        }}
                      />
                      <div>
                        {intl.formatMessage({ id: "contactUs.workingHour2" })}
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};
